import React, { useState, useEffect } from 'react';
import { Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import api from '@/pages/system/apis';

interface Props {
  value?: string;
  accept?: string;
  onChange?: (e: any) => {};
}
interface FileList {
  uid?: string;
  name: string;
  status: string;
  url: string;
}
const UploadFile = (props: Props) => {
  const { value, onChange = () => {}, accept = 'text/plain' } = props;
  const [fileList, setFileList] = useState([] as FileList[]);

  useEffect(() => {
    if (value) {
      setFileList([
        {
          name: value,
          status: 'done',
          url: value,
        },
      ]);
    }
  }, [value]);

  const customRequest = ({ file, onError }: any) => {
    const formData = new FormData();
    formData.append('file', file);
    setFileList([
      {
        name: file.name,
        status: 'uploading',
        url: '',
      },
    ]);
    api
      .uploadFile(formData)
      .then((res) => {
        const { ret } = res;
        if (ret === '0' && res.data) {
          setFileList([
            {
              name: res.data.files[0].name,
              status: 'done',
              url: res.data.urlList[0],
            },
          ]);
          onChange(res.data.urlList[0]);
        } else {
          onError();
        }
      })
      .catch(onError);

    return {
      abort() {
        console.log('upload progress is aborted.');
      },
    };
  };

  return (
    // @ts-ignore
    <Upload customRequest={customRequest} maxCount={1} fileList={fileList} accept={accept}>
      <Button icon={<UploadOutlined />}>上传</Button>
      <div className="crowd-pin">
        【特殊说明】种子pin包，用于后续在进行流程策略运营时，进行种子用户圈选和用户扩展；支持上传txt文本
      </div>
    </Upload>
  );
};

export default UploadFile;
